module.exports = __webpack_public_path__ + "img/undTooth2.96af0037.png";